module.exports = __webpack_public_path__ + "media/images/card-1-bfe19c4a335b1dd1dbb58e25fd91e59e.jpg";